@if (standalone()) {
<div class="loading-wrapper">
  <ng-container *ngTemplateOutlet="loading" />
</div>
} @else {
<div class="loading" [ngClass]="{ 'full-page-loading': fullPage() }"></div>
}

<ng-template #loading>
  <div class="loading" [ngClass]="{ 'full-page-loading': fullPage() }"></div>
</ng-template>
